import clickupLogo from "@static/img/clickup.png";
import githubLogo from "@static/img/github.png";
import hubspotLogo from "@static/img/hubspot.png";
import jiraLogo from "@static/img/jira-icon.png";
import linearLogo from "@static/img/linear.png";
import salesforceLogo from "@static/img/salesforce.png";
import topicflowLogo from "@static/img/topicflow-logo-no-text.svg";
import youtrackLogo from "@static/img/youtrack.svg";

import { classNames } from "@helpers/css";
import { getAssetUrl } from "@helpers/helpers";

export enum IntegrationLogoType {
  Github = "Github",
  Jira = "Jira",
  Salesforce = "Salesforce",
  Clickup = "Clickup",
  Hubspot = "Hubspot",
  Linear = "Linear",
  YouTrack = "YouTrack",
  Topicflow = "Topicflow",
}

export const getIntegrationLogoType = (node: { __typename: string }) => {
  if (node.__typename === "GithubIssueNode") {
    return IntegrationLogoType.Github;
  } else if (node.__typename === "JiraIssueNode") {
    return IntegrationLogoType.Jira;
  } else if (node.__typename === "SalesforceOpportunityNode") {
    return IntegrationLogoType.Salesforce;
  } else if (node.__typename === "ClickupTaskNode") {
    return IntegrationLogoType.Clickup;
  } else if (node.__typename === "HubspotDealNode") {
    return IntegrationLogoType.Hubspot;
  } else if (
    node.__typename === "LinearIssueNode" ||
    node.__typename === "LinearProjectNode"
  ) {
    return IntegrationLogoType.Linear;
  } else if (
    node.__typename === "YouTrackIssueNode" ||
    node.__typename === "YouTrackProjectNode"
  ) {
    return IntegrationLogoType.YouTrack;
  } else if (node.__typename === "TopicflowArtifactNode") {
    return IntegrationLogoType.Topicflow;
  }
  return undefined;
};

const IntegrationLogo = ({
  type,
  size = 4,
  className = "",
}: {
  type?: IntegrationLogoType;
  size?: number;
  className?: string;
}) =>
  type === IntegrationLogoType.Github ? (
    <img
      src={getAssetUrl(githubLogo)}
      alt="GitHub"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.Jira ? (
    <img
      src={getAssetUrl(jiraLogo)}
      alt="Jira"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.Salesforce ? (
    <img
      src={getAssetUrl(salesforceLogo)}
      alt="Salesforce"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.Topicflow ? (
    <img
      src={getAssetUrl(topicflowLogo)}
      alt="Topicflow"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.Clickup ? (
    <img
      src={getAssetUrl(clickupLogo)}
      alt="Clickup"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.Hubspot ? (
    <img
      src={getAssetUrl(hubspotLogo)}
      alt="Hubspot"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.Linear ? (
    <img
      src={getAssetUrl(linearLogo)}
      alt="Linear"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : type === IntegrationLogoType.YouTrack ? (
    <img
      src={getAssetUrl(youtrackLogo)}
      alt="YouTrack"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : null;

export default IntegrationLogo;
